/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

export default {
  /**
   * Object properties
   * id: Unique identifier,
   * message: Locale key | Actual text
   * [named]: Locale name formatting keys
   */
  items: [],
};
